import React, { Fragment, useRef } from 'react';
import WordWrapEllipse from '../WordWrapEllipse';
import { useNavigate } from 'react-router-dom';
import { DAM_SVG } from '../DamAssets';
import { MODULE_IDS, useHasAccess } from 'actions/userActions';

// 'key validator design layout'
// '1 - just normal click with mouse'
// '2 - the case when the ctrl key and mouse is clicked at the time'
// '3 - the case when we click shift and click in which we will select all the previous '

const ImageGridSecondVersion = ({
  Data,
  EllipseActions,
  ClickHanlde,
  isValidViewsSection = false,
  Index = 0,
  isSelected,
  HandleSelect,
  fromBrandAssets,
  single,
  accept,
  trash
}) => {
  const lastKeyPressTime = useRef(0);
  const lastKey = useRef(null);
  const navigate = useNavigate();
  var isEllipse = useHasAccess(MODULE_IDS.DAM)
  // Handle mouse clicks with modifier keys
  const handleMouseClick = (e) => {
    if (single) {
      HandleSelect({
        Image: Data,
        Key: 1,
      });
      return 
    }
        
    if (e.button === 0 && !e.ctrlKey && !e.shiftKey) {
      HandleSelect({
        Image: Data,
        Key: 1,
      });
    }
  if(!single){
    if (e.shiftKey && e.button === 0) {
      HandleSelect({
        Image: Data,
        Key: 3,
      });
    }

    if (e.ctrlKey && !e.shiftKey) {
      HandleSelect({
        Image: Data,
        Key: 2,
      });
    }

    if (e.altKey) {
    }
  }
  };

  // Handle double mouse clicks
  const handleDoubleClick = (e) => {
    // HandleSelect(Data);
    if(fromBrandAssets || trash){
      return
    }
    navigate('/dam/dam-asset-information_v2', { state: { props: Data?.damFileId } });

    if (e.shiftKey) {
    }
  };

  // Handle keyboard keys like Shift + Enter + detect double presses
  const handleKeyDown = (e) => {
    const now = Date.now();

    if (e.shiftKey && e.key === 'Enter') {
    }

    if (e.ctrlKey && e.key === 'Enter') {
    }

    if (e.altKey && e.key === 'Enter') {
    }

    // Detect double key press (same key within 400ms)
    if (lastKey.current === e.key && now - lastKeyPressTime.current < 400) {
    }

    lastKey.current = e.key;
    lastKeyPressTime.current = now;
  };

  return (
    <Fragment>
      <div
        key={Index}
        tabIndex={Index} // Makes the div focusable for key events
        className={`dam_common_hover ${isSelected && 'dam_selected_design'}`}
        style={{ position: 'relative' }}
        onClick={handleMouseClick} // Mouse click
        onDoubleClick={handleDoubleClick} // Mouse double click
        onKeyDown={handleKeyDown} // Keyboard + double key detection
      >
        {!isValidViewsSection ? (
          <div>
            <div
              className="sc-jvSbVl fIOSnp"
              style={{
                background: '#d9d9d9',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
              }}
            >
              <div
                className="sc-iSCiO eJERrS src-modules-MediaLibrary-AssetDisplay-AssetDisplay__asset-card-thumbnail--6ef5c box-link flex flex-grow items-center justify-center h-100 relative"
                data-test="asset-display"
              >
                <div
                  className="src-modules-MediaLibrary-AssetLoader-AssetLoader__assetLoader--VDHLE sc-hiEoHn jCisBi assetLoaded asset-loader flex justify-center items-center h-100 w-100 flex-grow"
                  data-test="asset-loader"
                  data-testid="asset-loader"
                >
                  <div className="tc h-inherit flex flex-column justify-center items-center thumbnail-img h-100 w-100">
                    <img
                      data-test-specifier="cloudinary-logo-vector"
                      role="img"
                      fetchpriority="auto"
                      className="fs-exclude src-modules-MediaLibrary-AssetLoader-AssetLoader__assetImage--kyidA"
                      src={Data.src}
                      alt="cloudinary-logo-vector"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>
            {Data?.isImage ? (
              <div>
                <div
                  className="image_container_2nd_version_image_section"
                  style={{ backgroundImage: `url(${Data?.src})` }}
                />
              </div>
            ) : Data?.isVideo ? (
              <div>
                <video
                  src={Data?.src}
                  className="image_container_2nd_version_image_section"
                  style={{
                    width: '100%',
                  }}
                  controls
                />
              </div>
            ) : Data?.isPdf ? (
              <div>
                <iframe
                  src={Data?.src}
                  title={Data?.fileName}
                  className="image_container_2nd_version_image_section"
                  style={{
                    width: '100%',
                  }}
                />
              </div>
            ) : (
              <div>
                <div className="image_container_2nd_version_image_section d-flex justify-content-center align-items-center">
                  {Data?.fileName.split('.').pop().toUpperCase()}
                </div>
              </div>
            )}
          </div>
        )}

        <div
          style={{
            padding: '16px',
            display: 'flex',
            justifyContent: 'space-between',
            bottom: 0,
            width: '100%',
            borderRadius: '0px 0px 8px 8px',
            alignItems: 'center',
          }}
        >
          <div className="d-flex gap-2 align-items-center">
            {/* <div
              className="image_container_2nd_version_image_section_2nd"
              style={{ backgroundImage: `url(${Data?.src})` }}
            /> */}
            {isValidViewsSection ? (
              <div>
                {' '}
                {Data?.isImage
                  ? DAM_SVG.imagePreviewIcons
                  : Data?.isPdf
                    ? DAM_SVG.pdfPreviewIcons
                    : Data?.isVideo
                      ? DAM_SVG.videoPreviewIcon
                      : DAM_SVG.otherPreviewIcon}{' '}
              </div>
            ) : (
              <div>
                {' '}
                {Data?.assetType === 'document'
                  ? DAM_SVG.pdfPreviewIcons
                  : Data?.assetType === 'image'
                    ? DAM_SVG?.imagePreviewIcons
                    : Data?.assetType === 'video'
                      ? DAM_SVG.videoPreviewIcon
                      : DAM_SVG.otherPreviewIcon}
              </div>
            )}

            <div>
              <div className="image_container_2nd_version_image_section_2nd_header d-flex">
                <WordWrapEllipse Text={Data?.fileName} MaxWidth={'12ch'} showTooltip={false} />
              </div>
              {/* <div className="image_container_2nd_version_image_section_2nd_description">
                Shared with me
              </div> */}
            </div>
          </div>
          {
            isEllipse && (
              <div
                style={{
                  cursor: 'pointer'
                }}
                onClick={(e) => e.stopPropagation()} // stop click bubbling
                onDoubleClick={(e) => e.stopPropagation()} // stop double-click bubbling
                onKeyDown={(e) => e.stopPropagation()} // stop key events bubbling
              >
                {typeof EllipseActions === 'function'
                  ? EllipseActions(Data)
                  : EllipseActions}
              </div>
            )
          }

        </div>
      </div>
    </Fragment>
  );
};

export default ImageGridSecondVersion;
